import { auth, googleProvider, githubProvider, facebookProvider } from './config/firebase'
import { signInWithPopup, signOut, onAuthStateChanged } from 'firebase/auth'
import { useState, useEffect } from 'react'
import Tetris from './pages/Tetris'
import Snake from './pages/Snake'
import Pong from './pages/Pong'
import Breakout from './pages/Breakout'
import SanCode from './pages/SanCode'
import CodeInBug from './pages/CodeInBug'
import KillerDeveloper from './pages/KillerDeveloper'
import Menu from './pages/Menu'
import { processReferral, getReferralCodeFromUrl } from './utils/referralService'

function App() {

  const [user, setUser] = useState(null)
  const [currentGame, setCurrentGame] = useState(null)

  // Garante que body tenha a classe game-active quando estiver em jogo
  useEffect(() => {
    if (currentGame) {
      document.body.classList.add('game-active')
    } else {
      document.body.classList.remove('game-active')
    }
    
    return () => {
      document.body.classList.remove('game-active')
    }
  }, [currentGame])

  // Mantém o estado do usuário sincronizado com o Firebase Auth
  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (currentUser) => {
      setUser(currentUser)
      
      // Processa indicação se houver código na URL e usuário acabou de logar
      if (currentUser) {
        const referralCode = getReferralCodeFromUrl()
        if (referralCode) {
          console.log('Processing referral code:', referralCode)
          const result = await processReferral(currentUser.uid, referralCode)
          
          if (result && result.success) {
            console.log('Referral processed successfully:', result)
          }
          
          // Remove o código da URL
          window.history.replaceState({}, document.title, window.location.pathname)
        }
      }
    })
    return () => unsubscribe()
  }, [])

  async function login(provider) {
    try {
      const result = await signInWithPopup(auth, provider)
      console.log('User data:', {
        displayName: result.user.displayName,
        email: result.user.email,
        photoURL: result.user.photoURL,
        uid: result.user.uid
      })
      setUser(result.user)
    } catch (error) {
      console.error('Login error:', error)
    }
  }

  function handleLogout() {
    signOut(auth)
    setCurrentGame(null)
  }

  function handleSelectGame(gameId) {
    setCurrentGame(gameId)
  }

  function handleBackToMenu() {
    setCurrentGame(null)
  }

  if (!user) {
    return (
      <div style={{
        textAlign: 'center',
        marginTop: 80,
        minHeight: '100vh',
        background: 'linear-gradient(135deg, #0f2027 0%, #2c5364 100%)',
        color: '#fff',
        fontFamily: 'Segoe UI, Arial, sans-serif',
        padding: '20px',
        paddingBottom: '60px',
      }}>
        <div style={{
          display: 'flex',
          justifyContent: 'center',
          marginBottom: 30,
        }}>
          <img 
            src="/logo.png" 
            alt="San Dev Code Logo" 
            style={{
              width: 200,
              height: 200,
              objectFit: 'contain',
              filter: 'drop-shadow(0 0 20px #00eaff)',
            }}
          />
        </div>
        <h1 style={{
          fontSize: 56,
          letterSpacing: 4,
          marginBottom: 5,
          fontWeight: 900,
          textShadow: '0 4px 24px #00eaff, 0 1px 0 #222',
          position: 'relative',
          zIndex: 10,
          background: 'linear-gradient(90deg, #00eaff 0%, #005bea 50%, #00eaff 100%)',
          WebkitBackgroundClip: 'text',
          WebkitTextFillColor: 'transparent',
          backgroundClip: 'text',
        }}>
          SAN DEV CODE
        </h1>
        <h2 style={{
          fontSize: 32,
          letterSpacing: 6,
          marginBottom: 10,
          fontWeight: 900,
          color: '#00eaff',
          textShadow: '0 0 20px #00eaff',
          position: 'relative',
          zIndex: 10,
        }}>
          RETRO GAMES
        </h2>
        <p style={{
          fontSize: 16,
          color: '#aaa',
          fontStyle: 'italic',
          marginBottom: 30,
        }}>
          Reviva os clássicos da era 8-bits
        </p>
        <style>{`
          .login-btn {
            background: linear-gradient(90deg, #00eaff 0%, #005bea 100%);
            color: #fff;
            border: none;
            border-radius: 30px;
            padding: 16px 40px;
            margin: 12px 0;
            font-size: 1.2rem;
            font-weight: bold;
            letter-spacing: 1px;
            box-shadow: 0 2px 16px #00eaff44;
            cursor: pointer;
            transition: transform 0.2s, box-shadow 0.2s;
            outline: none;
          }
          .login-btn:hover {
            transform: scale(1.07) rotate(-2deg);
            box-shadow: 0 4px 32px #00eaff99;
            background: linear-gradient(90deg, #005bea 0%, #00eaff 100%);
          }
          .tetris-blocks {
            display: flex;
            justify-content: center;
            margin-bottom: 30px;
            gap: 8px;
          }
          .block {
            width: 32px;
            height: 32px;
            background: linear-gradient(135deg, #00eaff 60%, #005bea 100%);
            border-radius: 6px;
            box-shadow: 0 2px 8px #00eaff88;
            animation: float 1.5s infinite alternate;
          }
          .block:nth-child(2) { animation-delay: 0.3s; }
          .block:nth-child(3) { animation-delay: 0.6s; }
          .block:nth-child(4) { animation-delay: 0.9s; }
          @keyframes float {
            from { transform: translateY(0); }
            to { transform: translateY(-18px) scale(1.1); }
          }
          .ad-container {
            margin: 30px auto;
            padding: 20px;
            max-width: 728px;
            background: rgba(0, 234, 255, 0.05);
            border: 2px solid rgba(0, 234, 255, 0.2);
            border-radius: 15px;
            backdrop-filter: blur(10px);
          }
          .ad-label {
            font-size: 10px;
            color: #00eaff88;
            margin-bottom: 10px;
            letter-spacing: 1px;
          }
        `}</style>
        <div className="tetris-blocks">
          <div className="block"></div>
          <div className="block"></div>
          <div className="block"></div>
          <div className="block"></div>
        </div>

        <button className="login-btn" onClick={() => login(googleProvider)}>Entrar com Google</button><br/>
        <button className="login-btn" onClick={() => login(facebookProvider)}>Entrar com Facebook</button><br/>
        <button className="login-btn" onClick={() => login(githubProvider)}>Entrar com GitHub</button>

        <p style={{marginTop: 40, fontSize: 16, color: '#00eaff99'}}>
          Desenvolvido por <a href="https://github.com/jusansilva" target="_blank" rel="noopener noreferrer" style={{color:'#00eaff', textDecoration:'underline', fontWeight:600}}>San Dev Code</a>
        </p>
      </div>
    )
  }

  // Se está logado mas sem jogo selecionado, mostra o menu
  if (user && !currentGame) {
    return (
      <Menu 
        user={user} 
        onSelectGame={handleSelectGame}
        onLogout={handleLogout}
      />
    )
  }

  // Se está logado e com jogo selecionado, mostra o jogo
  if (user && currentGame === 'tetris') {
    return (
      <div style={{ position: 'relative' }}>
        <button 
          onClick={handleBackToMenu}
          style={{
            position: 'absolute',
            top: 20,
            left: 20,
            background: 'rgba(0, 234, 255, 0.2)',
            border: '2px solid #00eaff',
            color: '#fff',
            padding: '12px 24px',
            borderRadius: '50px',
            cursor: 'pointer',
            fontSize: '14px',
            fontWeight: 'bold',
            letterSpacing: '1px',
            transition: 'all 0.3s',
            zIndex: 100,
            textTransform: 'uppercase',
          }}
          onMouseOver={(e) => {
            e.target.style.background = 'rgba(0, 234, 255, 0.5)'
            e.target.style.transform = 'scale(1.05)'
          }}
          onMouseOut={(e) => {
            e.target.style.background = 'rgba(0, 234, 255, 0.2)'
            e.target.style.transform = 'scale(1)'
          }}
        >
          ← Menu
        </button>
        <button 
          onClick={handleLogout}
          style={{
            position: 'absolute',
            top: 20,
            right: 20,
            background: 'rgba(255, 0, 0, 0.2)',
            border: '2px solid #ff0000',
            color: '#fff',
            padding: '12px 24px',
            borderRadius: '50px',
            cursor: 'pointer',
            fontSize: '14px',
            fontWeight: 'bold',
            letterSpacing: '1px',
            transition: 'all 0.3s',
            zIndex: 100,
            textTransform: 'uppercase',
          }}
          onMouseOver={(e) => {
            e.target.style.background = 'rgba(255, 0, 0, 0.5)'
            e.target.style.transform = 'scale(1.05)'
          }}
          onMouseOut={(e) => {
            e.target.style.background = 'rgba(255, 0, 0, 0.2)'
            e.target.style.transform = 'scale(1)'
          }}
        >
          Sair
        </button>
        <Tetris user={user} onBackToMenu={handleBackToMenu} />
      </div>
    )
  }

  if (user && currentGame === 'snake') {
    return (
      <div style={{ position: 'relative' }}>
        <button 
          onClick={handleBackToMenu}
          style={{
            position: 'absolute',
            top: 20,
            left: 20,
            background: 'rgba(0, 240, 0, 0.2)',
            border: '2px solid #00f000',
            color: '#fff',
            padding: '12px 24px',
            borderRadius: '50px',
            cursor: 'pointer',
            fontSize: '14px',
            fontWeight: 'bold',
            letterSpacing: '1px',
            transition: 'all 0.3s',
            zIndex: 100,
            textTransform: 'uppercase',
          }}
          onMouseOver={(e) => {
            e.target.style.background = 'rgba(0, 240, 0, 0.5)'
            e.target.style.transform = 'scale(1.05)'
          }}
          onMouseOut={(e) => {
            e.target.style.background = 'rgba(0, 240, 0, 0.2)'
            e.target.style.transform = 'scale(1)'
          }}
        >
          ← Menu
        </button>
        <button 
          onClick={handleLogout}
          style={{
            position: 'absolute',
            top: 20,
            right: 20,
            background: 'rgba(255, 0, 0, 0.2)',
            border: '2px solid #ff0000',
            color: '#fff',
            padding: '12px 24px',
            borderRadius: '50px',
            cursor: 'pointer',
            fontSize: '14px',
            fontWeight: 'bold',
            letterSpacing: '1px',
            transition: 'all 0.3s',
            zIndex: 100,
            textTransform: 'uppercase',
          }}
          onMouseOver={(e) => {
            e.target.style.background = 'rgba(255, 0, 0, 0.5)'
            e.target.style.transform = 'scale(1.05)'
          }}
          onMouseOut={(e) => {
            e.target.style.background = 'rgba(255, 0, 0, 0.2)'
            e.target.style.transform = 'scale(1)'
          }}
        >
          Sair
        </button>
        <Snake user={user} onBackToMenu={handleBackToMenu} />
      </div>
    )
  }

  if (user && currentGame === 'pong') {
    return (
      <div style={{ position: 'relative' }}>
        <button 
          onClick={handleBackToMenu}
          style={{
            position: 'absolute',
            top: 20,
            left: 20,
            background: 'rgba(240, 240, 0, 0.2)',
            border: '2px solid #f0f000',
            color: '#fff',
            padding: '12px 24px',
            borderRadius: '50px',
            cursor: 'pointer',
            fontSize: '14px',
            fontWeight: 'bold',
            letterSpacing: '1px',
            transition: 'all 0.3s',
            zIndex: 100,
            textTransform: 'uppercase',
          }}
          onMouseOver={(e) => {
            e.target.style.background = 'rgba(240, 240, 0, 0.5)'
            e.target.style.transform = 'scale(1.05)'
          }}
          onMouseOut={(e) => {
            e.target.style.background = 'rgba(240, 240, 0, 0.2)'
            e.target.style.transform = 'scale(1)'
          }}
        >
          ← Menu
        </button>
        <button 
          onClick={handleLogout}
          style={{
            position: 'absolute',
            top: 20,
            right: 20,
            background: 'rgba(255, 0, 0, 0.2)',
            border: '2px solid #ff0000',
            color: '#fff',
            padding: '12px 24px',
            borderRadius: '50px',
            cursor: 'pointer',
            fontSize: '14px',
            fontWeight: 'bold',
            letterSpacing: '1px',
            transition: 'all 0.3s',
            zIndex: 100,
            textTransform: 'uppercase',
          }}
          onMouseOver={(e) => {
            e.target.style.background = 'rgba(255, 0, 0, 0.5)'
            e.target.style.transform = 'scale(1.05)'
          }}
          onMouseOut={(e) => {
            e.target.style.background = 'rgba(255, 0, 0, 0.2)'
            e.target.style.transform = 'scale(1)'
          }}
        >
          Sair
        </button>
        <Pong user={user} onBackToMenu={handleBackToMenu} />
      </div>
    )
  }

  if (user && currentGame === 'breakout') {
    return (
      <div style={{ position: 'relative' }}>
        <button 
          onClick={handleBackToMenu}
          style={{
            position: 'absolute',
            top: 20,
            left: 20,
            background: 'rgba(240, 160, 0, 0.2)',
            border: '2px solid #f0a000',
            color: '#fff',
            padding: '12px 24px',
            borderRadius: '50px',
            cursor: 'pointer',
            fontSize: '14px',
            fontWeight: 'bold',
            letterSpacing: '1px',
            transition: 'all 0.3s',
            zIndex: 100,
            textTransform: 'uppercase',
          }}
          onMouseOver={(e) => {
            e.target.style.background = 'rgba(240, 160, 0, 0.5)'
            e.target.style.transform = 'scale(1.05)'
          }}
          onMouseOut={(e) => {
            e.target.style.background = 'rgba(240, 160, 0, 0.2)'
            e.target.style.transform = 'scale(1)'
          }}
        >
          ← Menu
        </button>
        <button 
          onClick={handleLogout}
          style={{
            position: 'absolute',
            top: 20,
            right: 20,
            background: 'rgba(255, 0, 0, 0.2)',
            border: '2px solid #ff0000',
            color: '#fff',
            padding: '12px 24px',
            borderRadius: '50px',
            cursor: 'pointer',
            fontSize: '14px',
            fontWeight: 'bold',
            letterSpacing: '1px',
            transition: 'all 0.3s',
            zIndex: 100,
            textTransform: 'uppercase',
          }}
          onMouseOver={(e) => {
            e.target.style.background = 'rgba(255, 0, 0, 0.5)'
            e.target.style.transform = 'scale(1.05)'
          }}
          onMouseOut={(e) => {
            e.target.style.background = 'rgba(255, 0, 0, 0.2)'
            e.target.style.transform = 'scale(1)'
          }}
        >
          Sair
        </button>
        <Breakout user={user} onBackToMenu={handleBackToMenu} />
      </div>
    )
  }

  if (user && currentGame === 'sancode') {
    return (
      <div style={{ position: 'relative' }}>
        <button 
          onClick={handleBackToMenu}
          style={{
            position: 'absolute',
            top: 20,
            left: 20,
            background: 'rgba(0, 212, 255, 0.2)',
            border: '2px solid #00d4ff',
            color: '#fff',
            padding: '12px 24px',
            borderRadius: '50px',
            cursor: 'pointer',
            fontSize: '14px',
            fontWeight: 'bold',
            letterSpacing: '1px',
            transition: 'all 0.3s',
            zIndex: 100,
            textTransform: 'uppercase',
          }}
          onMouseOver={(e) => {
            e.target.style.background = 'rgba(0, 212, 255, 0.5)'
            e.target.style.transform = 'scale(1.05)'
          }}
          onMouseOut={(e) => {
            e.target.style.background = 'rgba(0, 212, 255, 0.2)'
            e.target.style.transform = 'scale(1)'
          }}
        >
          ← Menu
        </button>
        <button 
          onClick={handleLogout}
          style={{
            position: 'absolute',
            top: 20,
            right: 20,
            background: 'rgba(255, 0, 0, 0.2)',
            border: '2px solid #ff0000',
            color: '#fff',
            padding: '12px 24px',
            borderRadius: '50px',
            cursor: 'pointer',
            fontSize: '14px',
            fontWeight: 'bold',
            letterSpacing: '1px',
            transition: 'all 0.3s',
            zIndex: 100,
            textTransform: 'uppercase',
          }}
          onMouseOver={(e) => {
            e.target.style.background = 'rgba(255, 0, 0, 0.5)'
            e.target.style.transform = 'scale(1.05)'
          }}
          onMouseOut={(e) => {
            e.target.style.background = 'rgba(255, 0, 0, 0.2)'
            e.target.style.transform = 'scale(1)'
          }}
        >
          Sair
        </button>
        <SanCode 
          user={user} 
          onBackToMenu={handleBackToMenu}
          userProgress={null}
        />
      </div>
    )
  }

  if (user && currentGame === 'codeinbug') {
    return (
      <CodeInBug 
        user={user} 
        onBackToMenu={handleBackToMenu}
        userProgress={null}
      />
    )
  }

  if (user && currentGame === 'killerdeveloper') {
    return (
      <KillerDeveloper 
        user={user} 
        onBackToMenu={handleBackToMenu}
      />
    )
  }

  return null
}

export default App
